import { VUELTAS } from '../actions/types';

const initialState = {
    listado: [],
    informacion: null
};

export default (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case VUELTAS.BUSCAR:
            return { ...state, listado: payload };

        case VUELTAS.INFORMACION:
            return { ...state, informacion: payload };

        case VUELTAS.LIMPIAR:
            return { ...state, informacion: null };

        default:
            return state;
    }
};
